<template>
  <el-card class="box-card show-point mb-25 mt-35">
    <el-avatar :size="150" :src="staff.avatar_image_url" class="avatar"/>
    <p class="nickname"><span>{{ staff.nickname }}</span></p>
    <img src="/images/logo_bg.png" class="logo"/>
    <p class="text-point-in-current-month">{{ $t('point_in_current_month') }}</p>
    <p class="show">
      <span class="point">{{ data.point_in_current_month }}</span>
    </p>
    <!-- <p class="money">({{ data.money_in_current_month }})</p> -->
    <p class="transaction-datetime" v-if="data.date_start && this.data.date_end">
     {{ starttDateCurrentMonth }}〜{{ currentDate }} {{ $t('time_point')}}
    </p>
  </el-card>
  <el-card class="box-card search-report-point">
    <el-row class="title">
      <el-col :span="24">
        <label class="font-weight-700">{{ $t('staff.earn_kokoron_detail.title') }}</label>
        <span class="btn-open-close" @click="handleScreenEarnDetail">
          {{ textBtn }}
        </span>
      </el-col>
    </el-row>
    <el-divider />
    <div v-if="showEarnScreenDetail">
      <form-search-date @get-point-and-money="getPointAndMoney"></form-search-date>
      <el-divider />
      <div class="main">
        <label class="title">{{ $t('earn_kokoro') }}</label>
        <p class="content">
          <span class="point">{{ point }}<span class="pt"> ココロン</span></span>
          <!-- <span class="money">({{ money }})</span> -->
        </p>
      </div>
    </div>
  </el-card>
</template>
<script>
  import { getPointAndMoney } from '../../api/staff'
  import { CURRENT_YEAR, CURRENT_MONTH, CURRENT_DAY } from '../../constants'

  export default {
    props: {
      staff: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      site: { type: Number, required: false },
      role: { type: Number, required: false },
      data: { type: Object, required: true, default: {} },
    },
    data() {
      return {
        isOpenPopupReset: false,
        textBtn: this.$t('staff.earn_kokoron_detail.close'),
        showEarnScreenDetail: true,
        point: 0,
        money: 0,
        showAlert: false,
        alert: {
          type: '',
          message: ''
        },
        form: {
          start: {
            year: CURRENT_YEAR,
            month: CURRENT_MONTH,
            day: '01'
          },
          end: {
            year: CURRENT_YEAR,
            month: CURRENT_MONTH,
            day: CURRENT_DAY
          }
        },
        starttDateCurrentMonth: this.$dayjs(this.data.date_start).format('YYYY/MM/DD'),
        currentDate: this.$dayjs(this.data.date_end).format('YYYY/MM/DD'),
      }
    },
    methods: {
      formatDate(dateTime) {
        return (dateTime) ? this.$dayjs(dateTime).format('YYYY/MM/DD') : '';
      },

      handleScreenEarnDetail(periodStart, periodEnd) {
        this.showEarnScreenDetail = !this.showEarnScreenDetail;
        this.textBtn = this.showEarnScreenDetail ?
                      this.$t('staff.earn_kokoron_detail.close')
                      : this.$t('staff.earn_kokoron_detail.open_show_poin');
      },

      getPointAndMoney(data) {
        getPointAndMoney(this.staff.id, data)
        .then(response => response.json())
        .then(response => {
          this.point = response.data.point;
          this.money = response.data.money;
        })
      }
    },

    created() {
      this.starttDateCurrentMonth = this.data.date_start ? this.$dayjs(this.data.date_start).format('YYYY/MM/DD') : this.$dayjs(new Date(this.form.start.year, this.form.start.month - 1, this.form.start.day)).format('YYYY/MM/DD');
      this.currentDate = this.data.date_end ? this.$dayjs(this.data.date_end).format('YYYY/MM/DD') : this.$dayjs(new Date(this.form.end.year, this.form.end.month - 1, this.form.end.day)).format('YYYY/MM/DD');
      const data = { period_start: this.starttDateCurrentMonth, period_end: this.currentDate};
      this.getPointAndMoney(data);
    },
  }
</script>
<style lang="scss">
  .show-point {
    width: 450px;
    height: 530px;
    text-align: center;

    .avatar {
      margin-top: 24px;
      background-color: #E9E5DF;
    }

    .logo {
      width: 59px;
      height: 41px;
    }

    .nickname {
      margin: 12px 0 12px;
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      font-weight: 700;
    }

    .text-point-in-current-month {
      font: normal normal normal 15px/33px Kozuka Gothic Pr6N;
      letter-spacing: 1.5px;
      color: #000000;
      margin: 8px 0 16px;
    }

    .show {
      margin: 0;
      .point {
        font: normal normal normal 60px/50px Futura;
        letter-spacing: 0.6px;
        color: #000000;
        font-weight: 700
      }
    }
    .money {
      font: normal normal normal 18px/30px Futura;
      letter-spacing: 0.6px;
      color: #000000;
      margin: 0;
      font-weight: 700;
    }

    .transaction-datetime {
      margin: 16px 0 0;
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
    }
  }

  .search-report-point {
    margin-bottom: 50px;
    .el-divider--horizontal {
      margin: 10px 0;
    }
    .title {
      font: normal normal normal 15px/33px Kozuka Gothic Pr6N;
      letter-spacing: 1.5px;
      color: #000000;
      .btn-open-close {
        font: normal normal normal 11px/20px Kozuka Gothic Pr6N;
        letter-spacing: 1.1px;
        color: #969696;
        margin-left: 20px;
        cursor: pointer;
      }
      padding-bottom: 0px;
    }
    .main {
      color: #000000;
      .title {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        font-weight: 700;
      }
      .content {
        .point {
          font: normal normal bold 25px/23px Futura;
          letter-spacing: 0.25px;
          .pt {
            font-size: 20px;
          }
        }
        .money {
          font: normal normal bold 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          margin-left: 10px;
        }
      }
    }
  }
</style>
